$shm_hitalama_textbook_text $mol_text
	Header* $shm_hitalama_textbook_text_header
		minimal_height 40
		level <= header_level*
		content <= block_content*
		arg <= header_arg*

$shm_hitalama_textbook_text_header $mol_text_header
